/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class Filter {

    /** @type {string} */
    #name;
    /** @type {string|null} */
    #color;
    /** @type {boolean} */
    #hideInTable;
    /** @type {function(Transaction):boolean|null} */
    #filterFunc;
    /** @type {boolean} */
    #synthetic;

    /**
     *
     * @param name {string}
     * @param [options] {{
     *     color?: string|null,
     *     hideInTable?: boolean,
     *     filterFunc?: function(Transaction):boolean|null,
     *     synthetic?: boolean
     * }}
     */
    constructor(name, options = {}) {
        this.#name = name;
        this.#color = options.color ?? null;
        this.#hideInTable = options.hideInTable === true;
        this.#filterFunc = options.filterFunc ?? null;
        this.#synthetic = options.synthetic === true;
    }

    getName() {
        return this.#name;
    }

    getColor() {
        return this.#color;
    }

    isHiddenInTable() {
        return this.#hideInTable;
    }

    isSynthetic() {
        return this.#synthetic;
    }

    hasFilterFunc() {
        return this.#filterFunc != null;
    }

    /**
     *
     * @param transaction {Transaction}
     * @return {boolean}
     */
    matches(transaction) {
        if (this.#filterFunc == null) {
            return true;
        }
        return this.#filterFunc(transaction);
    }
}
